import { useTranslation } from 'react-i18next'

export const useFilters = () => {
	const { t } = useTranslation()

	return [
		{
			id: 'type',
			label: t('Type'),
			placeholder: t('All'),
			options: [
				{
					value: 'active',
					label: t('Active')
				},
				{
					value: 'administrator',
					label: t('Administrator')
				},
				{
					value: 'superuser',
					label: t('Superuser')
				}
			]
		},
		{
			id: 'payout_requested',
			label: t('Payout status'),
			placeholder: t('All'),
			options: [
				{
					value: 'true',
					label: t('Requested')
				},
				{
					value: 'false',
					label: t('Not requested')
				}
			]
		}
	]
}
